module.exports = __webpack_public_path__ + "img/MEDIA033.d6e96675.jpg";